import { IStoreState } from 'modules/types';

export const getLobbyData = (state: IStoreState) => state.lobby.lobby;
export const getLobbyKeynotesData = (state: IStoreState) => state.lobby.lobby.keynotes;
export const getLobbyLoading = (state: IStoreState) => state.lobby.isFetching;
export const getLobbySocialLinks = (state: IStoreState) => state.lobby.lobby.social;
